import { api } from 'services/api';
import {
  EncashResponse,
  EncashSumResponse,
  ReportForm,
  WithPaginationParams
} from 'types';
import { saveAs } from 'file-saver';

interface EncashParams {
  from: string;
  to: string;
  url: string;
}

const encashApi = api
  .enhanceEndpoints({
    addTagTypes: ['ENCASH']
  })
  .injectEndpoints({
    endpoints: (build) => ({
      getEncashes: build.query<
        EncashResponse,
        WithPaginationParams<EncashParams>
      >({
        query: ({ url, ...params }) => ({
          url,
          method: 'GET',
          params
        }),
        providesTags: (_res, _err, params) => [
          {
            type: 'ENCASH',
            id: params.url
          }
        ]
      }),
      getEncashSum: build.query<EncashSumResponse, EncashParams>({
        query: ({ url, ...params }) => ({
          url: `${url}/sum`,
          method: 'GET',
          params
        })
      }),
      downloadEncashReport: build.mutation<
        void,
        EncashParams & { form?: ReportForm }
      >({
        query: ({ url, form = ReportForm.file, ...params }) => ({
          url,
          method: 'GET',
          params: {
            ...params,
            form
          },
          transformResponse: (data, headers: Record<string, string>) => {
            const fileName =
              headers['content-disposition'] || 'filename=report.csv';
            const [, name, ext] =
              fileName.replace(/\s/g, '_').match(/filename=(\S+)\.(\w+)/) || [];
            saveAs(new Blob(['\uFEFF', data]), `${name}.${ext}`);
          }
        })
      }),
      addEncashComment: build.mutation<
        void,
        { url: string; data: { Comment: string }; id: string }
      >({
        query: ({ url, data, id }) => ({
          method: 'POST',
          url: `${url}/${id}`,
          data
        }),
        invalidatesTags: (_res, err, params) =>
          err
            ? []
            : [
                {
                  type: 'ENCASH',
                  id: params.url
                }
              ]
      })
    })
  });

export const {
  useDownloadEncashReportMutation,
  useGetEncashSumQuery,
  useGetEncashesQuery,
  useAddEncashCommentMutation
} = encashApi;
